// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A widget for displaying state-specific results for the US presidential, senate and congressional elections.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "US Votes 2020 state results widget",
  id: "us-votes2020-state-results",
  groupsWithAccess: ["specialist_user", "editor_user"],
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/2020/us-election-2020-state-results/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "UsVotes2020StateResultsConfigTool" */ "app/components/tools/UsVotes2020StateResultsConfigTool/UsVotes2020StateResultsConfigTool"),
    loading: DynamicImportLoader,
    modules: ["UsVotes2020StateResultsConfigTool"]
  })
};

export default CONFIG;
